import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  connect () {
    this.saveFacilityViewed(this.facilityId())
  }

  saveFacilityViewed (id) {
    const TTL = 90 * 24 * 60 * 60 * 1000 // 90 days
    const now = Date.now()
    let data = {}
    try { data = JSON.parse(localStorage.getItem('cs.readFacilities') || '{}') } catch (e) {}
    data[id] = now
    for (const k in data) if (now - data[k] > TTL) delete data[k]
    try { localStorage.setItem('cs.readFacilities', JSON.stringify(data)) } catch (e) {}
  }

  facilityId () {
    return this.element.dataset.facilityid
  }
}
